module.exports = __webpack_public_path__ + "static/other/npc_following_demo_map.6bc1ba82.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/npc_following_demo_map.json
// module id = 2765
// module chunks = 0